import { groupAdminPath } from "./constants";
import { SCREEN_IDS } from "../../system/global-enums";

import Managers from "./views/managers/managers";
import GroupProfile from "./views/groupProfile/groupProfile";
import GroupPerformance from "./views/groupPerformance/groupPerformance";

import Inbox from "../shared-screens/views/inbox/inbox";
import UserProfile from "../shared-screens/views/userProfile/userProfile";
import UserPermissions from "../shared-screens/views/userPermissions/userPermissions";
import ConsumerResponses from "../shared-screens/views/consumerResponses/consumerResponses";
import IndividualStoreProfile from "../shared-screens/views/individualStoreProfile/individualStoreProfile";
import IndividualStorePerformance from "../shared-screens/views/individualStorePerformance/individualStorePerformance";
import Dashboard from "../shared-screens/views/dashboard/dashboard";
import MarketingAttributionReport from "../shared-screens/views/marketingAttributionReport/marketingAttributionReport";

const GroupRoutes = [
  {
    path: groupAdminPath.GROUP_PROFILE,
    name: "brand-restaurants",
    screenId: SCREEN_IDS.BRANDS,
    component: GroupProfile,
    displayName: "Group Stores",
    breadcrumb: "Group Profile",
  },
  {
    path: groupAdminPath.GROUP_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS,
    component: GroupPerformance,
    displayName: "Group Performance",
    breadcrumb: "Group Performance",
  },
  {
    path: groupAdminPath.GROUP_USER_MANAGERS,
    name: "managers",
    screenId: SCREEN_IDS.BRANDS,
    component: Managers,
    displayName: "Managers",
    breadcrumb: "Group Managers",
  },
  // Consumer Responses
  {
    path: groupAdminPath.CONSUMER_RESPONSES_BY_PERFORMANCE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: groupAdminPath.CONSUMER_RESPONSES_BY_GROUP_PROFILE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: groupAdminPath.CONSUMER_RESPONSES_BY_GROUP_MANAGERS,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  // Individual Performance
  {
    path: groupAdminPath.STORE_PERFORMANCE_BY_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: groupAdminPath.STORE_PERFORMANCE_BY_GROUP_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: groupAdminPath.STORE_PERFORMANCE_BY_GROUP_MANAGERS,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  // Individual Store Profile
  {
    path: groupAdminPath.STORE_PROFILE_BY_PERFORMANCE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: groupAdminPath.STORE_PROFILE_BY_GROUP_PROFILE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: groupAdminPath.STORE_PROFILE_BY_GROUP_MANAGERS,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: groupAdminPath.USER_PROFILE,
    name: "userProfile",
    screenId: SCREEN_IDS.BRANDS,
    component: UserProfile,
    displayName: "User Profile",
    breadcrumb: "User Profile",
  },
  {
    path: groupAdminPath.GROUP_USER_PERMISSIONS,
    name: "user-permissions",
    screenId: SCREEN_IDS.BRANDS,
    component: UserPermissions,
    displayName: "User Permissions",
    breadcrumb: "Permissions",
  },
  {
    path: groupAdminPath.GROUP_INBOX,
    name: "group-inbox",
    screenId: SCREEN_IDS.BRANDS,
    component: Inbox,
    displayName: "Messages",
    breadcrumb: "Group Inbox",
  },
  {
    path: groupAdminPath.DASHBOARD_BY_GROUP_ADMIN,
    name: "dashboard",
    screenId: SCREEN_IDS.BRANDS,
    component: Dashboard,
    displayName: "Dashboard",
    breadcrumb: "Dashboard",
  },
  {
    path: groupAdminPath.MARKETING_ATTRIBUTION,
    name: "marketing-attribution",
    screenId: SCREEN_IDS.BRANDS,
    component: MarketingAttributionReport,
    displayName: "Marketing Attribution",
    breadcrumb: "Marketing Attribution",
  },
];

export default GroupRoutes;
